import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserAchievement } from 'src/app/models/user-achievement.model';
import { AchievementService } from 'src/app/services/achievement.service';

@Component({
  selector: 'app-achievements-index',
  templateUrl: './achievements-index.component.html',
  styleUrls: ['./achievements-index.component.scss']
})
export class AchievementsIndexComponent implements OnInit {
  area = "global";
  isLoading = false;
  weeklyParticipationBadges: UserAchievement[] = [];
  nextParticipationStreak = 3;
  // walking
  walkingWorkoutMilestones: UserAchievement[] = [];
  nextWalkingWorkoutMilestone = "";
  walkingGoals: UserAchievement[] = [];
  nextWalkingGoalAward = "";
  walkingStreaks: UserAchievement[] = [];
  nextWalkingStreak = "";

  // strength
  strengthWorkoutMilestones: UserAchievement[] = [];
  nextStrengthWorkoutMilestone = "";
  strengthGoals: UserAchievement[] = [];
  nextStrengthGoalAward = "";
  strengthStreaks: UserAchievement[] = [];
  nextStrengthStreak = "";

  // yoga
  yogaWorkoutMilestones: UserAchievement[] = [];
  nextYogaWorkoutMilestone = "";
  yogaGoals: UserAchievement[] = [];
  nextYogaGoalAward = "";
  yogaStreaks: UserAchievement[] = [];
  nextYogaStreak = "";

  allAchievements: UserAchievement[] = [];
  uniqueAchievements: UserAchievement[] = [];
  current = {
  };


  achievementsByArea:any = {};

  moveWellAreas = [
    {id:'prepSteps', label:'Prep Steps'},
    {id:'prepFit', label:'Prep Fit'},
    {id:'breatheWell', label:'Breathe Well'},
    {id:'prepStrong', label:'Prep Strong'},
  ]


  moduleAreas = [
    {id:'iQuit', label:'I Quit'},
    {id:'drinkGuide', label:'Drinking Guide'},
    {id:'eatWell', label:'Eat Well'},
    {id:'sleepWell', label:'Sleep Well'},
    {id:'feelWell', label:'Feel Well'},
  ]
  
  constructor(
    private achievementService: AchievementService,
    private route: ActivatedRoute,
  ) {
    if (this.route.snapshot.data["area"]) {
      this.area = this.route.snapshot.data["area"];
    }
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.achievementService.fetchAll().subscribe((responseData) => {
      this.isLoading = false;

      this.allAchievements = responseData;
      this.uniqueAchievements = this.achievementService.getUnique(responseData);

      this.uniqueAchievements.forEach((achievement) => {
        if (achievement.type === "week-streak" && achievement.area=='prepWell') {
          this.weeklyParticipationBadges.push(achievement);
        }
      });

      // get nexts
      this.nextWalkingWorkoutMilestone =
        this.achievementService.getNextMilestone(
          "walking",
          "badge-workouts",
          this.allAchievements
        );
      this.nextStrengthWorkoutMilestone =
        this.achievementService.getNextMilestone(
          "strength",
          "badge-workouts",
          this.allAchievements
        );
      this.nextYogaWorkoutMilestone = this.achievementService.getNextMilestone(
        "yoga",
        "badge-workouts",
        this.allAchievements
      );

      this.nextWalkingGoalAward = this.achievementService.getNextMilestone(
        "walking",
        "badge-goals",
        this.allAchievements
      );
      this.nextStrengthGoalAward = this.achievementService.getNextMilestone(
        "strength",
        "badge-goals",
        this.allAchievements
      );
      this.nextYogaGoalAward = this.achievementService.getNextMilestone(
        "yoga",
        "badge-goals",
        this.allAchievements
      );

      this.nextWalkingStreak = this.achievementService.getNextMilestone(
        "walking",
        "badge-workout-streak",
        this.allAchievements
      );
      this.nextStrengthStreak = this.achievementService.getNextMilestone(
        "strength",
        "badge-workout-streak",
        this.allAchievements
      );
      this.nextYogaStreak = this.achievementService.getNextMilestone(
        "yoga",
        "badge-workout-streak",
        this.allAchievements
      );

      // get currents
      /*
      forkJoin({
        allGoals: this.goalService.fetchAll(),
        allWalks: this.walkingService.fetchAll(),
        allStrengthWorkouts: this.strengthWorkoutService.fetchAll(),
        allYogaWorkouts: this.yogaWorkoutService.fetchAll(),
      }).subscribe(
        (responseData) => {
          this.current.walkingWorkouts = responseData.allWalks.length;
          this.current.strengthWorkouts =
            responseData.allStrengthWorkouts.length;
          this.current.yogaWorkouts = responseData.allYogaWorkouts.length;
          responseData.allGoals.forEach((goal) => {
            if (goal.status == 1) {
              switch (goal.area) {
                case "walking":
                  this.current.walkingGoals++;
                  break;
                case "strength":
                  this.current.strengthGoals++;
                  break;
                case "yoga":
                  this.current.yogaGoals++;
                  break;
              }
            }
          });

          // do the streaks..
          this.current.walkingStreak = this.walkingService.getCurrentStreak(
            responseData.allWalks
          );
          this.current.strengthStreak =
            this.strengthWorkoutService.getCurrentStreak(
              responseData.allStrengthWorkouts
            );
          this.current.yogaStreak = this.yogaWorkoutService.getCurrentStreak(
            responseData.allYogaWorkouts
          );
        },
        (error) => {}
      );*/
    });
  }
  achievementCount(area: string, type: string, total: number) {
    let count = 0;
    this.allAchievements.forEach((achievement) => {
      if (
        achievement.type == type &&
        achievement.area == area &&
        achievement.total == total
      ) {
        count++;
      }
    });
    return count;
  }

  getPopoverContent(achievement: UserAchievement) {
    // Awarded for working out {{achievement.total}} days in a row. Awarded {{achievementCount(achievement.area, achievement.type, achievement.total)}} times.

    let html = "";
    if (achievement.type == "week-streak") {
      html =
        html +
        "Awarded for logging in  " +
        achievement.total.toString() +
        " weeks in a row.";
    } else {
      html =
        html +
        "Awarded for working out " +
        achievement.total.toString() +
        " days in a row.";
    }
    const totalawarded = this.achievementCount(
      achievement.area,
      achievement.type,
      achievement.total
    );
    html = html + " Awarded " + totalawarded.toString() + " time";
    if (totalawarded == 1) {
      html = html + ".";
    } else {
      html = html + "s.";
    }

    return html;
  
  }

  getByArea(area:string){
   return this.allAchievements.filter((achievement) => {
      return achievement.area == area;
  });
  }
  
}
